import * as gs from "@ivanlog/gs";
import { CmpBtnInfoBase } from "./tmpls";

export class CmpBtnInfo extends CmpBtnInfoBase {

    private static _ActiveBtn:CmpBtnInfo;

    private _clickHandler:any;
    constructor() {
        super();
        this._clickHandler=(e)=>{
            gs.events.stop(e);
            this._close();
        }
        this.ctrls.btn.onclick=(e)=>{
           if (CmpBtnInfo._ActiveBtn) CmpBtnInfo._ActiveBtn._close();
            gs.events.stop(e);
            document.addEventListener('click',this._clickHandler);
            this.ctrls.lText.show();
            CmpBtnInfo._ActiveBtn = this;
            const rect = this.ctrls.lText.el.getBoundingClientRect();

            const isOverflowingRight = rect.right > window.innerWidth;
            if (isOverflowingRight) this.ctrls.lText.addClass('left');
            else if (rect.left<0) this.ctrls.lText.removeClass('left');
        }
    }
    private _close()
    {
        document.removeEventListener('click',this._clickHandler);
        this.ctrls.lText.hide();
        if (CmpBtnInfo._ActiveBtn==this) CmpBtnInfo._ActiveBtn=undefined;
    }
}